/* src/app/pages/clubs/club-add/club-add.page.scss */
.buttons-row {
  width: 100%;
}
ion-radio::part(label) {
  display: block !important;
}
/*# sourceMappingURL=club-add.page.css.map */
